module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/badges_png/reward_badge_silver-4931347e8eae53d0c719eec836a6640e.png";